export default __webpack_public_path__ + "static/logo-0107f53a15b964034ecd79e027a15f41.svg";